import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { Input } from '../../../../../../components/Common/UI/Input';
import Separator from '../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../components/Common/UI/Button';
import { cn } from '../../../../../../utils/styles';
import { IDeliveryModal } from '../Delivery';
import DataTable from '../../../../../../components/Common/UI/DataTable';
import { IPaperlessRes, paperlessCol, paperlessData } from './Data';

interface IModalPaperlessHistory {
  open: boolean;
  handleOpen: (payload: IDeliveryModal) => void;
}

function ModalPaperlessHistory({ handleOpen, open }: IModalPaperlessHistory) {
  const [search, setSearch] = useState<string>();
  const [data, setData] = useState<IPaperlessRes[]>([]);

  useEffect(() => {
    setData(paperlessData);
  }, []);

  const handleSearch = (payload?: string) => {
    setSearch(payload);

    if (!payload || payload.length < 3) {
      setData(paperlessData);

      return;
    }

    setData(
      paperlessData.filter(el => {
        const combinedFields = `${el.modifiedBy} ${el.modifiedDate} ${el.newStatus} ${el.oldStatus}`.toLowerCase();

        return combinedFields.includes(payload.toLowerCase());
      }),
    );
  };

  return (
    <Dialog open={open} onOpenChange={e => handleOpen({ open: e, type: 'history', statement: 'checkingStatement' })}>
      <DialogContent className={cn('max-h-[98%] max-w-[1200px]')}>
        <DialogTitle className="w-full h-auto flex gap-[20px] items-start">
          <div className="bg-[#307BB2] p-[7px] rounded-lg">
            <Icons.Timer className="size-[15px] text-white" />
          </div>
          <div className="grid gap-[5px]">
            <div>Paperless History</div>
            <span className="text-[16px] text-addition1-60 font-normal">Some text description</span>
          </div>
        </DialogTitle>

        <div className="grid gap-[20px] mt-[10px]">
          <Input
            className="w-[385px]"
            placeholder="Type to search"
            icon={<Icons.Search />}
            variant="white"
            value={search}
            onChange={e => handleSearch(e.target.value)}
          />
          <DataTable columns={paperlessCol} data={data} initialState={{ pagination: { pageSize: 5 } }} />
        </div>
        <Separator className="m-0" />
        <div className="flex justify-end">
          <Button variant="default" className="py-3 !bg-addition5 hover:opacity-85 px-[30px]">
            <Icons.DownloadIconNew />
            Download
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalPaperlessHistory;
